<template>
  <div
    id="partner"
    :style="{ backgroundColor: country === 'hongkong' ? '#f7f8f9' : '' }"
  >
    <div class="inner">
      <div class="top">
        <div class="top_box_l">
          <div
            class="top_title"
            :style="{
              fontSize: ['zh_CN', 'zh_HK'].includes($i18n.locale)
                ? '1.2rem'
                : '1.3rem',
              height: ['zh_CN', 'zh_HK'].includes($i18n.locale)
                ? '2.20833vw'
                : '5.20833vw',
            }"
          >
            {{ $t("home_partner_title") }}
          </div>
          <div class="top_desc_title">
            {{ $t("home_partner_contact_title") }}
          </div>
          <div class="top_desc">
            {{ $t("home_partner_contact_desc") }}
          </div>
        </div>
        <div
          class="top_tabs"
          :style="{ backgroundColor: country === 'hongkong' ? '#ffffff' : '' }"
        >
          <div class="top_tabs_t" v-if="country !== 'uk'">
            <div
              class="tab-item"
              :class="activeTab === 1 ? 'tab-active' : 'tab-inactive'"
              @click="tabClick(1)"
            >
              {{ $t("home_partner_tab_partner") }}
            </div>
            <div
              class="tab-item"
              :class="activeTab === 0 ? 'tab-active' : 'tab-inactive'"
              @click="tabClick(0)"
            >
              {{ $t("home_partner_tab_agent") }}
            </div>
          </div>
          <div class="top_content">
            <div class="top_content_r">
              <!-- 姓名、邮箱所有tab都显示 -->
              <div
                class="div_input"
                :style="{
                  marginTop: country === 'uk' ? '40px' : '',
                }"
                contenteditable="true"
                :placeholder="$t('home_partner_input_name')"
                @input="onInput('name', $event)"
                @mouseleave="onMouseLeave($event)"
              ></div>
              <div
                class="div_input"
                contenteditable="true"
                :placeholder="$t('home_partner_input_email')"
                @input="onInputEmail($event)"
                @mouseleave="onMouseLeave($event)"
              ></div>

              <!-- Partner tab 且香港版时，显示额外三个输入框 -->
              <template v-if="activeTab === 1 && country === 'hongkong'">
                <PhoneInput
                  :prefix="phonePrefix"
                  :prefix-list="phonePrefixList"
                  :clear-trigger="phoneInputClearKey"
                  :dropdown-visible="phonePrefixDropdown"
                  @toggle-dropdown="togglePhonePrefixDropdown"
                  @select-prefix="selectPhonePrefix"
                  @mobile="onInput('mobile', $event)"
                  @mouseleave="onMouseLeave($event)"
                />
                <div
                  class="div_input"
                  contenteditable="true"
                  :placeholder="$t('home_partner_input_whatsapp')"
                  @input="onInput('whatsApp', $event)"
                  @mouseleave="onMouseLeave($event)"
                ></div>
                <div
                  class="div_input"
                  contenteditable="true"
                  :placeholder="$t('home_partner_input_budget')"
                  @input="onInput('budget', $event)"
                  @mouseleave="onMouseLeave($event)"
                ></div>
              </template>

              <!-- Agent tab -->
              <template v-if="activeTab === 0">
                <!-- 香港版Agent多四个输入框 -->
                <template v-if="country === 'hongkong'">
                  <div
                    class="div_input"
                    contenteditable="true"
                    :placeholder="$t('home_partner_input_whatsapp')"
                    @input="onInput('whatsApp', $event)"
                    @mouseleave="onMouseLeave($event)"
                  ></div>
                  <PhoneInput
                    :prefix="phonePrefix"
                    :prefix-list="phonePrefixList"
                    :clear-trigger="phoneInputClearKey"
                    :dropdown-visible="phonePrefixDropdown"
                    @toggle-dropdown="togglePhonePrefixDropdown"
                    @select-prefix="selectPhonePrefix"
                    @mobile="onInput('mobile', $event)"
                    @mouseleave="onMouseLeave($event)"
                  />
                  <div
                    class="div_input"
                    contenteditable="true"
                    :placeholder="$t('home_partner_input_store_name')"
                    @input="onInput('storeName', $event)"
                    @mouseleave="onMouseLeave($event)"
                  ></div>
                  <div
                    class="div_input"
                    contenteditable="true"
                    :placeholder="$t('home_partner_input_store_address')"
                    @input="onInput('location', $event)"
                    @mouseleave="onMouseLeave($event)"
                  ></div>
                  <div
                    class="div_input"
                    contenteditable="true"
                    :placeholder="$t('home_partner_input_store_type')"
                    @input="onInput('storeType', $event)"
                    @mouseleave="onMouseLeave($event)"
                  ></div>
                </template>
                <!-- 英国版Agent保持原本的 -->
                <template v-else>
                  <div
                    class="div_input"
                    contenteditable="true"
                    :placeholder="$t('home_partner_input_store_address')"
                    @input="onInput('location', $event)"
                    @mouseleave="onMouseLeave($event)"
                  ></div>
                  <div
                    class="div_input input_address"
                    contenteditable="true"
                    :placeholder="$t('home_partner_input_store_type')"
                    @input="onInput('storeType', $event)"
                    @mouseleave="onMouseLeave($event)"
                  ></div>
                </template>
              </template>
              <div class="button" @click="submit">
                {{ $t("home_partner_submit") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryByDomain } from "@/common/config";
import PhoneInput from "./PhoneInput.vue";
import { getClientTag } from "@/utils/index";

export default {
  name: "PartnerView",
  components: {
    PhoneInput,
  },
  data() {
    return {
      activeTab: 1,
      name: "",
      mail: "",
      mobile: "",
      whatsApp: "",
      budget: "",
      storeName: "",
      location: "",
      storeType: "",
      phonePrefixList: [],
      phonePrefix: "+852",
      phonePrefixDropdown: false,
      phoneRegionCode: "",
      emailError: "",
      phoneInputClearKey: 0,
    };
  },
  created() {
    if (this.country === "hongkong") {
      this.fetchRegionCodeList();
    }
  },
  methods: {
    onMouseLeave(event) {
      event.target.blur(); // 鼠标离开时让输入框失去焦点
    },
    tabClick(tabIndex) {
      this.activeTab = tabIndex;
      this.name = "";
      this.mail = "";
      this.mobile = "";
      this.whatsApp = "";
      this.budget = "";
      this.storeName = "";
      this.location = "";
      this.storeType = "";
      this.phonePrefixDropdown = false;
      this.$nextTick(() => {
        const editableDivs = this.$el.querySelectorAll(
          '.div_input[contenteditable="true"]'
        );
        editableDivs.forEach((div) => {
          div.innerText = "";
        });
      });
    },
    clearForm() {
      this.name = "";
      this.mail = "";
      this.mobile = "";
      this.whatsApp = "";
      this.budget = "";
      this.storeName = "";
      this.location = "";
      this.storeType = "";
      this.phonePrefixDropdown = false;
      this.phoneInputClearKey++;
      this.$nextTick(() => {
        const editableDivs = this.$el.querySelectorAll(
          '.div_input[contenteditable="true"]'
        );
        editableDivs.forEach((div) => {
          div.innerText = "";
        });
      });
    },
    togglePhonePrefixDropdown() {
      this.phonePrefixDropdown = !this.phonePrefixDropdown;
    },
    selectPhonePrefix(prefixObj) {
      this.phonePrefix = "+" + prefixObj.code;
      this.phonePrefixDropdown = false;
    },
    onInput(field, value) {
      if (field === "mobile" && typeof value === "object") {
        this.mobile = value.mobile;
        this.phoneRegionCode = value.regionCode;
      } else {
        this[field] =
          typeof value === "string"
            ? value.trim()
            : value?.target?.innerText?.trim() || "";
      }
    },
    onInputEmail(event) {
      const val = event.target.innerText.trim();
      this.mail = val;
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValid = emailReg.test(val);
      this.emailError = isValid ? "" : this.$t("home_partner_email_error");
    },
    checkContactValid() {
      // 英国只校验邮箱，其他国家校验邮箱和手机号
      if (
        this.country === "uk"
          ? !this.mail.trim()
          : !this.mail.trim() || !this.mobile.trim()
      ) {
        this.$message.error(this.$t("home_partner_error_contact"));
        return false;
      }
      return true;
    },
    async submit() {
      if (this.emailError) {
        this.$message.error(this.emailError);
        return;
      }
      if (!this.checkContactValid()) return;
      const params = {
        name: this.name,
        mail: this.mail,
        mobile: this.mobile,
        whatsApp: this.whatsApp,
        budget: this.budget,
        storeName: this.storeName,
        location: this.location,
        storeType: this.storeType,
        type: this.activeTab,
        regionCode: this.phoneRegionCode,
      };
      const res = await this.$axios.post(
        "/user/system/v1/enrollProspectivePartner",
        params
      );
      if (res.success === true || res.data) {
        this.$message.success(this.$t("home_partner_success_submit"));
        this.clearForm();
      } else {
        this.$message.error(
          res.data?.msg || this.$t("home_partner_success_error")
        );
      }
    },
    async fetchRegionCodeList() {
      const res = await this.$axios.get(
        "/user/system/v1/queryRegionCodeListForPartner"
      );
      if (
        res.data &&
        res.data.data &&
        Array.isArray(res.data.data) &&
        res.data.data.length > 0
      ) {
        this.phonePrefixList = res.data.data
          .flatMap((group) => group.data)
          .map((item) => ({ code: item.code }));
      }
    },
  },
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    clientTag() {
      return getClientTag(this.country);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
#partner {
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 120px 0;
  background-color: #ffffff;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    .top_box_l {
      color: #111111;
      width: 430.5px;
      min-width: 431px;
      .top_title {
        height: 100px;
        font-weight: 900;
        font-size: 1.3rem;
        line-height: 50px;
        font-family: $title-font;
      }
      .top_desc_title {
        margin-top: 40px;
        margin-bottom: 15px;
        font-weight: 700;
        font-size: $font-size-small;
        font-family: $content-font;
      }
      .top_desc {
        font-weight: 400;
        font-size: $font-size-mini;
        color: #999999;
        line-height: 28px;
        font-family: $content-font;
      }
    }
    .top_tabs {
      box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.08);
      margin-left: 100px;
      padding: 0px 40px;
      border-radius: 20px;

      .top_tabs_t {
        margin-bottom: 45px;
        margin-top: 26.5px;
        display: flex;
        text-align: center;
        font-weight: 600;
        font-size: $font-size-base;
        line-height: 46px;
        font-family: $content-font;

        .tab-item {
          width: 50%;
          text-align: center;
          cursor: pointer;

          &.tab-active {
            border-bottom: 2px #000000 solid;
          }

          &.tab-inactive {
            border-bottom: 1px #d8d8d8 solid;
          }
        }
      }

      .top_content {
        font-size: $font-size-mini;
        font-family: $content-font;

        .top_content_r {
          width: 590px;
        }

        .div_input {
          padding: 18px 20px;
          margin-bottom: 20px;
          border-radius: 12px;
          border: 1px solid #cccccc;

          &:empty:before {
            content: attr(placeholder);
            color: #999;
          }

          &:focus,
          &:focus-visible {
            border-color: #000;
            outline: none;
          }

          &:focus:before {
            content: "";
          }
        }

        .input_address {
          height: 108px;
        }

        .button {
          width: 196px;
          font-size: 0.47rem;
          border-radius: 39px;
          padding: 15px 30px;
          text-align: center;
          line-height: 34px;
          font-weight: 700;
          background: linear-gradient(108deg, #ffe74d 0%, #ffdd00 100%);
          margin-bottom: 40px;
          font-family: $content-font;
          cursor: pointer;
          transition: background 0.2s;

          &:hover {
            background: linear-gradient(
              108deg,
              rgba(255, 231, 77, 0.8) 0%,
              rgba(255, 221, 0, 0.8) 100%
            );
          }
        }
      }
    }
  }
}
</style>
